<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="bullseye"/>
          {{ $t('adminUserCommissionDetail') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <department-select class="mr-1 mb-1" :model="filterFormModel"></department-select>
            <group-select class="mr-1 mb-1" :model="filterFormModel"></group-select>
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="user"
                               :place-holder="$t('selectAdminUser')"></admin-user-select>
            <time-picker class="mr-1 mb-1" :model="filterFormModel" attribute="time" :unit="'month'"
                         :label="$t('chooseMonth')"></time-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['admin', 'owner', 'accountant', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <commission-export :filter="filterFormModel" :total-count="itemCount"></commission-export>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('adminUser') }}</div>
            <div class="col-lg-4">{{ $t('licence') }}</div>
            <div class="col-lg-4">{{ $t('callFee') }}</div>
          </div>
          <admin-user-commission-item v-for="item in items" :key="item._id" :item="item" :filter="filterFormModel"></admin-user-commission-item>
        </div>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import _ from "lodash";
import TimePicker from "@/components/TimePicker";
import AdminUserSelect from "@/components/AdminUserSelect";
import DepartmentSelect from "@/components/DepartmentSelect";
import GroupSelect from "@/components/GroupSelect";
import CommissionExport from "./CommissionExport";
import AdminUserCommissionItem from "./AdminUserCommissionItem";

export default {
  components: {AdminUserCommissionItem, CommissionExport, GroupSelect, DepartmentSelect, AdminUserSelect, TimePicker},
  mixins: [List],
  data() {
    return {
      service: '/admin-user',
      users: [],
      defaultFilterFormModel: {
        time: Date.now(),
        department: null,
        group: null,
        user: null,
        trigger: false
      },
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.filterFormModel.trigger = !this.filterFormModel.trigger;
      this.load();
    }, 200),
  },
  i18n: {
    messages: {
      en: {
        adminUserCommissionDetail: 'Admin user commission detail',
        adminUser: 'Admin user',
        licence: 'Licence',
        callFee: 'Call fee'
      },
      vi: {
        adminUserCommissionDetail: 'Hoa hồng chi tiết theo nhân viên',
        adminUser: 'Nhân viên',
        licence: 'Licence phần mềm',
        callFee: 'Cước gọi'
      }
    }
  }
}
</script>